// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex';
import App from './App'
import store from './store'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueScrollTo from 'vue-scrollto'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Feedback from './components/home-page-components/Feedback.vue'


Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.use(Vuetify, {
  theme: {
    primary: '#fff',
    secondary: '#ebf3ff',
    accent: '#8c9eff',
    error: '#b71c1c',
    blue: '#61ffff',
    blueDark: '#23436e',
    black: '#000',
    yellowLight: '#ffe357',
    grey: '#a4a5a4',
    greyDark: '#3e3e3e',
    greyLight: '#fdfdfd'
  },
});

Vue.use(Vuex);

Vue.config.productionTip = false;

AOS.init({
  disable: false,
  duration: 1000,
  offset: 180
});

Vue.component('Feedback', Feedback);
Vue.directive('scroll', {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  },
});

Vue.prototype.$eventHub = new Vue()
Vue.prototype.$apiHost = ''

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
  name: 'app',
  store
});







// WEBPACK FOOTER //
// ./src/main.js